import styles from "./AddMultiCollectionModal.module.scss";
import Modal from "src/components/modal/Modal";
import Button from "src/components/button/Button";
import { useCallback, useState } from "react";
import Spinner from "@src/components/spinner/Spinner";
import { SelectOption } from "@src/types";
import {
  SllProgram,
  useAddMcToProgramMutation,
} from "@src/api/graphql-codegen";
import { useToast } from "@src/hooks";
import SelectMulti from "@src/components/select-multi/SelectMulti";
import { logger } from '../../../../utils/logger';

type Props = {
  open: boolean;
  mcCollectionOptions?: SelectOption[] | [];
  onClose: () => void;
  onAdded: () => void;
  program: SllProgram
};

function AddMultiCollectionModal(props: Props) {
  const { open, program, mcCollectionOptions = [], onClose, onAdded } = props;
  const [addMultiCollections, setAddMultiCollections] = useState<Array<string>>(
    []
  );

  const { successToast, errorToast } = useToast();

  const [addMCToProgram, { loading }] =
    useAddMcToProgramMutation({
      onCompleted(data, clientOptions) {
        if (data.addMCToProgram) {
          successToast("Multi Collection has been added successfully!");
          onAdded();
        } else {
          errorToast("Create failed, Please try again!");
        }
      },
      onError(e) {
        logger.debug(`[e]`, e);
        errorToast(e.message)
      },
    });

  const handleClose = () => {
    onClose();
  };

  const handleAddToProgram = useCallback(() => {
    const mcInfo = addMultiCollections.map((mc, index) => {
      return {
        mcId: mc,
        position: program.mcs ? index + 1 + program.mcs?.length : index + 1
      }
    })

    if (mcInfo.length > 0) {
      addMCToProgram({
        variables: {
          input: {
            mcInfo,
            programId: program.id
          }
        }
      })
    }
  }, [
    program,
    addMultiCollections,
    addMCToProgram
  ]);

  const handleChangeMultiSelect = useCallback((options: string[]) => {
    setAddMultiCollections(options);
  }, []);

  return (
    <Modal open={open} onClose={handleClose} className={styles.wrapper}>
      <div>
        <div className={styles.addTitle}>Add Multi-Collection To Program</div>
        <div className={styles.addMCDetail}>
          <div className={styles.subTitle}>Multi-Collection</div>
          <SelectMulti
            label={""}
            options={mcCollectionOptions}
            value={addMultiCollections}
            onChange={handleChangeMultiSelect}
            showSearch={true}
            doNotSort={true}
            menuClassName={styles.selectorStyle}
            showVertical={true}
          />
        </div>
        <div className={styles.action}>
          <Button
            disabled={loading}
            size="small"
            leftIcon={
              loading ? (
                <Spinner width={20} height={20} />
              ) : undefined
            }
            className={styles.cancelButton}
            onClick={onClose}
            label={"CANCEL"}
          />
          <Button
            disabled={addMultiCollections.length === 0 || loading}
            size="small"
            leftIcon={
              loading ? (
                <Spinner width={20} height={20} />
              ) : undefined
            }
            className={styles.addMCButton}
            onClick={handleAddToProgram}
            label={"ADD TO PROGRAM"}
          />
        </div>
      </div>
    </Modal>
  );
}

export default AddMultiCollectionModal;
